import { useMutation } from '@tanstack/react-query';

import type { ApiError } from '@/_shared';
import { apiClient } from '@/_shared';

import type {
  CommissionsCreateSchema,
  CommissionsFormSchema,
  CommissionsMutationSchema,
} from './schemas/commissions-schemas';

// commission plans APIs
export const useCommissionBulkCreateMutation = () =>
  useMutation<CommissionsFormSchema[], ApiError, { items: CommissionsCreateSchema[] }>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/agreement-commissions/bulk-store',
        payload,
      }),
  });

export const useCommissionBulkUpdateMutation = () =>
  useMutation<{ data: { id: number } }, ApiError, { items: CommissionsMutationSchema[] }>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/agreement-commissions/bulk-update',
        payload,
      }),
  });

export const useCommissionBulkDeleteMutation = () =>
  useMutation<
    { data: { id: number } },
    ApiError,
    {
      items: number[];
    }
  >({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/agreement-commissions/bulk-delete',
        payload,
      }),
  });

export const useGetCalculateAgreementCommissionMutation = () =>
  useMutation<
    { one_time_commission_total: number; recurring_commission_total: number; cumulative_sales: number },
    ApiError,
    { agreement_id: number; team_member_id: number }
  >({
    mutationFn: ({ agreement_id, team_member_id }) =>
      apiClient.get({
        endpoint: `/api/v1/calculate-agreement-commission/?team_member_id=${team_member_id}&agreement_id=${agreement_id}`,
      }),
  });
